var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_18061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_18061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46634 12.15L5.76634 11.45L7.29967 9.91666L5.76634 8.38333L6.46634 7.68333L7.99967 9.21666L9.53301 7.68333L10.233 8.38333L8.69967 9.91666L10.233 11.45L9.53301 12.15L7.99967 10.6167L6.46634 12.15ZM3.53301 14.3333C3.19967 14.3333 2.91634 14.2167 2.68301 13.9833C2.44967 13.75 2.33301 13.4667 2.33301 13.1333V4.2C2.33301 3.86666 2.44967 3.58333 2.68301 3.35C2.91634 3.11666 3.19967 2.99999 3.53301 2.99999H4.46634V1.58333H5.48301V2.99999H10.533V1.58333H11.533V2.99999H12.4663C12.7997 2.99999 13.083 3.11666 13.3163 3.35C13.5497 3.58333 13.6663 3.86666 13.6663 4.2V13.1333C13.6663 13.4667 13.5497 13.75 13.3163 13.9833C13.083 14.2167 12.7997 14.3333 12.4663 14.3333H3.53301ZM3.53301 13.3333H12.4663C12.5108 13.3333 12.5552 13.3111 12.5997 13.2667C12.6441 13.2222 12.6663 13.1778 12.6663 13.1333V6.86666H3.33301V13.1333C3.33301 13.1778 3.35523 13.2222 3.39967 13.2667C3.44412 13.3111 3.48856 13.3333 3.53301 13.3333Z",
    fill: "#FE6666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.4a052d6b5cd63d2c1a40a0bfee08424f.svg";
export { ForwardRef as ReactComponent };